import React from 'react';
import { Text } from '../../../../../components/Typography/Typography';
import { ClientConversation, ConversationPreview } from '../../../../../store/chat/types';
import ConversationGroup from './ConversationGroup';
import { groupConversationsByDate, getGroupKeys } from '../utils/groupConversations';
import styles from './ConversationList.module.scss';

interface ConversationListProps {
  conversations: ConversationPreview[];
  currentConversation: ClientConversation | null;
  onSelectConversation: (conversation: ConversationPreview) => void;
  isLoading: boolean;
}

const ConversationList: React.FC<ConversationListProps> = ({
  conversations,
  currentConversation,
  onSelectConversation,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <div className={styles.loading}>
        <Text color="gray50">Loading conversations...</Text>
      </div>
    );
  }

  if (conversations.length === 0) {
    return (
      <div className={styles.empty}>
        <Text color="gray50">No conversations found</Text>
      </div>
    );
  }

  const groupedConversations = groupConversationsByDate(conversations);
  const groupKeys = getGroupKeys(groupedConversations);

  return (
    <div className={styles.list}>
      {groupKeys.map(key => (
        <ConversationGroup
          key={key}
          title={key}
          conversations={groupedConversations[key]}
          currentConversation={currentConversation}
          onSelectConversation={onSelectConversation}
        />
      ))}
    </div>
  );
};

export default ConversationList;
